import { render, staticRenderFns } from "./DragHandle.vue?vue&type=template&id=6f0f6b76&"
import script from "./DragHandle.vue?vue&type=script&lang=ts&"
export * from "./DragHandle.vue?vue&type=script&lang=ts&"
import style0 from "./DragHandle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports